module.exports = __webpack_public_path__ + "img/hand-shake.809455f9.png";